angular
	.module('vppApp')
	.service('CreateAccountService', CreateAccountService);
CreateAccountService.$inject = ['$http', '$rootScope', 'dobFilter'];
function CreateAccountService($http, $rootScope, dobFilter) {
	var createAccountService = {};
	var _createAccountStep = "step1";
	var _securityQuestions = {};
	var _accountDetails = {};
	var _resetAccountDetails = angular.copy(_accountDetails);
	var _securityDetails = {};
	var _moduleDetails = {};
	var _userMigrationDetails = {};
	var _userAccountInput = {};
	createAccountService.userFirstName;
	createAccountService.userLastName;
	createAccountService.userEmailAddress;
	// SUP & DED - step1, step2, step3, logged-in goto "view-auth" 
	// MPP & GMED - step1, step2, step3, logged-in goto "view-auth"
	// cgp - step1, step2, step3, logged-in goto "view-auth"
	// emp - step1, step2, logged-in goto "view-auth"

	// what step am I in
	createAccountService.getCreateAccountStep = function () {
		return _createAccountStep;
	};
	createAccountService.setCreateAccountStep = function (whichStep) {
		_createAccountStep = whichStep;
	};
	createAccountService.setSecurityQuestions = function (securityQuestions) {
		_securityQuestions = securityQuestions;
	};
	createAccountService.getSecurityQuestions = function () {
		return _securityQuestions;
	};
	createAccountService.getAccountDetails = function () {
		return _accountDetails;
	};

	createAccountService.getAccountMigrationDetails = function () {
		return _userMigrationDetails;
	}

	createAccountService.getAccountMigrationUserInput = function () {
		return _userAccountInput;

	}

	createAccountService.setAccountDetails = function (accountDetails) {
		_accountDetails = accountDetails;
		// adds slashes to DOB.
		_accountDetails.accountDetails.dateOfBirth = dobFilter(_accountDetails.accountDetails.dateOfBirth);
	};

	createAccountService.updateNickNameAccountDetails = function (accountDetails) {
		_accountDetails.accountDetails.nicknameFirstName = accountDetails.nicknameFirstName;
		_accountDetails.accountDetails.nicknameLastName = accountDetails.nicknameLastName;
	}
	// removes slashes from DOB so dobFilter works in form.
	createAccountService.unSetAccountDetails = function () {
		_accountDetails.accountDetails.dateOfBirth = _accountDetails.accountDetails.dateOfBirth.replace(/\//g, '');
	};

	createAccountService.setUserDetails = function (firstName, lastName, email) {
		createAccountService.userFirstName = firstName;
		createAccountService.userLastName = lastName;
		createAccountService.userEmailAddress = email;
	};
	createAccountService.setSecurityDetails = function (securityDetails) {
		_securityDetails = securityDetails;
	};
	createAccountService.setModuleDetails = function (moduleDetails) {
		_moduleDetails = moduleDetails;
	};

	createAccountService.setAccountMigrationDetails = function (userMigrationDetails) {
		_userMigrationDetails = userMigrationDetails;
	}

	createAccountService.setAccountMigrationUserInput = function (userAccountInput) {
		_userAccountInput = userAccountInput;
	}

	createAccountService.resetAccountData = function () {
		_accountDetails = {};
		var _tempResetAccountData = angular.copy(_resetAccountDetails);
		_accountDetails = angular.extend(_accountDetails, _tempResetAccountData);
	};

	createAccountService.buildRegistrationObj = function (whichSite) {
		// builds the Registration json Object for API
		//remove DOB from specific sites per GMIT Privacy
		if (whichSite === 'cgp' || whichSite === 'gmed') {
			delete _accountDetails.accountDetails.dateOfBirth;
		}
		var _tempRegisterObj;
		if (whichSite === 'emp') {
			_tempRegisterObj = angular.merge({}, _securityDetails, _accountDetails);
			_tempRegisterObj = angular.toJson(_tempRegisterObj);
			return _tempRegisterObj;
		} else {
			_tempRegisterObj = angular.merge({}, _accountDetails, _securityDetails, _moduleDetails);
			_tempRegisterObj = angular.toJson(_tempRegisterObj);
			return _tempRegisterObj;
		}
	};
	return createAccountService;
}